var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('div',{staticClass:"icon",on:{"click":function($event){return _vm.goBackward()}}},[_c('i',{staticClass:"material-icons",class:[_vm.getColorClass()]},[_vm._v("arrow_back")])])])}
var staticRenderFns = []

export { render, staticRenderFns }